import { Icone } from '../icone/icone';

export class Menu {
  id!: number;
  parentId!: number | null;
  label!: string;
  level!: number;
  root!: boolean;
  order!: string;
  expanded!: boolean;
  actived!: boolean;
  url!: string;
  children!: Menu[];
  icon!: Icone;

  static searchItem(
    treeItems: Menu[] | null,
    searchId: number | null | undefined
  ): Menu | null {
    let foundItem: Menu | null = null;

    if (treeItems) {
      for (let item of treeItems) {
        if (item.id === searchId) {
          foundItem = item;
          break;
        }

        if (item.children !== undefined && item.children.length > 0) {
          foundItem = this.searchItem(item.children, searchId);
        }
        if (foundItem !== null) break;
      }
    }
    return foundItem;
  }

  static parentKeyAbsent(treeItem: Menu | null): boolean {
    return treeItem?.parentId === undefined || treeItem.parentId === null;
  }

  /*static buildTree(node: Menu, parentId: number | null): Menu {
      let children: Menu[] = [];
      if (node?.children?.length > 0) {
        node.children.forEach(child =>
          children.push(this.buildTree(child, node.id))
        );
      }
      return {
        id: node.id,
        parentId: node.parentId === 1 ? null : parentId,
        label: node.label,
        level: node.nivel,
        root: node.nivel === 1,
        order: node.ordem.toString(),
        expanded: false,
        actived: false,
        url: node.url?.toString() ?? '',
        children: children,
        icon: {
          lib: node?.icone?.lib ?? '',
          nome: node?.icone?.nome ?? '',
          class: node?.icone?.class ?? '',
          cor: node?.icone?.cor ?? ''
        }
      };
    }*/
}
